export const SERVICES = [
  {
    icon: "🏢",
    title: "Commercial",
    description:
      "Basic Lawncare Maintenance, City Contracts, Small business contracts.",
  },
  {
    icon: "🏡",
    title: "Residential",
    description:
      "Lawncare Maintenance, leaf clean up, debris clean up, edging.",
  },
  {
    icon: "🌳",
    title: "Landscape",
    description:
      "Bush trimming, Flower Bed Renovation, Flower installation (excludes Design), Mulch.",
  },
];
